import Vue from 'vue'
import VueApollo from 'vue-apollo'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation'
import { GoogleMapsKey } from '../constants/settings.js'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

// List of components
const AlertCmp = () => import('../components/Shared/Alert.vue')
const ToolbarCmp = () => import('../components/Shared/Toolbar.vue')
const SnackbarCmp = () => import('../components/Shared/Snackbar.vue')

export const VueRegister = () => {
  Vue.use(VueApollo)
  Vue.use(Datetime)
  Vue.use(VueGeolocation)
  Vue.use(VueGoogleMaps, {
    load: {
      key: GoogleMapsKey,
      libraries: 'places'
    }
  })
  Vue.config.productionTip = false
  Vue.prototype.$log = console.log

  Vue.component('app-alert', AlertCmp)
  Vue.component('datetime', Datetime)
  Vue.component('app-toolbar', ToolbarCmp)
  Vue.component('app-snackbar', SnackbarCmp)

  return Vue
}



// WEBPACK FOOTER //
// ./src/lib/register.js